export default "__VITE_ASSET__kW7MEood__"